import { saveAs } from 'file-saver';

export const generateAndDownloadCsv = (data, fields, fileName) => {
  if (!data || data.length === 0) return;
  const joinData = data?.map((d) =>
    fields
      .map((field) => {
        if (typeof d[field.fieldName] === 'string' && d[field.fieldName]?.includes(',')) {
          return '"' + d[field.fieldName] + '"';
        }
        return d[field.fieldName];
      })
      .join(','),
  );
  const headers = fields?.map((c) => c.label?.replace('\r\n', ' '))?.join(',');
  const file = new Blob([headers + '\n' + joinData?.join('\n')], {
    type: 'text/csv;charset=utf-8;',
  });
  saveAs(file, fileName);
};

export const getFileName = (v) => {
  return v && v.split('/').pop();
};
